module.exports = __webpack_public_path__ + "img/pin.fd105aad.webp";